import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import logoLight from "@/assets/brand/logo-full-light.png";

export default function Footer() {
  return (
    <footer className="bg-[#1C1A17] text-[#FBF8F2] mt-20 grain-overlay relative">
      <div className="px-6 md:px-12 lg:px-24 py-24 grid grid-cols-1 md:grid-cols-12 gap-12 relative z-10">
        <div className="md:col-span-5">
          <img
            src={logoLight}
            alt="Dreamy Interiors"
            className="h-24 w-auto select-none"
            draggable="false"
          />
          <p className="mt-7 max-w-md text-base leading-[1.85] text-[#FBF8F2]/65 font-light">
            A Bengaluru-based interior design &amp; execution firm creating thoughtful, considered homes with a focus on design, quality and craftsmanship.
          </p>
          <p className="mt-4 text-xs tracking-[0.25em] uppercase text-[#C9A24A]/80">Crafted, not assembled.</p>
          <Link to="/book" className="btn-gold mt-10">Book Consultation <ArrowUpRight size={14}/></Link>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-[#C9A24A]">Explore</p>
          <ul className="mt-6 space-y-3.5 text-sm">
            <li><Link to="/portfolio" className="hover:text-[#C9A24A] transition-colors">Portfolio</Link></li>
            <li><Link to="/services" className="hover:text-[#C9A24A] transition-colors">Services</Link></li>
            <li><Link to="/estimator" className="hover:text-[#C9A24A] transition-colors">Cost Estimator</Link></li>
            <li><Link to="/assistant" className="hover:text-[#C9A24A] transition-colors">AI Assistant</Link></li>
            <li><Link to="/book" className="hover:text-[#C9A24A] transition-colors">Book Consultation</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-[#C9A24A]">Visit us</p>
          <ul className="mt-6 space-y-4 text-sm text-[#FBF8F2]/80">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-[#C9A24A]" />
              <a data-testid="footer-address" href="https://maps.app.goo.gl/uEEgdcfApZ5uhyXm7" target="_blank" rel="noreferrer" className="hover:text-[#C9A24A] transition-colors leading-relaxed">Hallehalli Road, Hallehalli, Kithiganur, Bengaluru 560036</a>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="mt-0.5 shrink-0 text-[#C9A24A]" />
              <span className="flex flex-col gap-1 leading-relaxed">
                <a data-testid="footer-phone-primary" href="tel:+917975399846" className="hover:text-[#C9A24A] transition-colors whitespace-nowrap">+91 79753 99846</a>
                <a data-testid="footer-phone-secondary" href="tel:+917975899846" className="hover:text-[#C9A24A] transition-colors whitespace-nowrap">+91 79758 99846</a>
              </span>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 shrink-0 text-[#C9A24A]" />
              <a data-testid="footer-email" href="mailto:hello@dreamyinteriors.in" className="hover:text-[#C9A24A] transition-colors break-all">hello@dreamyinteriors.in</a>
            </li>
            <li className="flex gap-3">
              <Instagram size={16} className="mt-0.5 shrink-0 text-[#C9A24A]" />
              <a data-testid="footer-instagram" href="https://instagram.com/dreamyinteriors.blr" target="_blank" rel="noreferrer" className="hover:text-[#C9A24A] transition-colors">@dreamyinteriors.blr</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 md:px-12 lg:px-24 py-7 text-xs text-[#FBF8F2]/45 flex flex-col md:flex-row justify-between gap-2 relative z-10">
        <span>© {new Date().getFullYear()} Dreamy Interiors. All rights reserved.</span>
        <span className="tracking-[0.25em] uppercase">Crafted in Bengaluru</span>
      </div>
    </footer>
  );
}
